/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.admin.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type ImportProgramMutationVariables = Types.Exact<{
  object: Types.ImportProgramInput;
}>;

export type ImportProgramMutation = { __typename?: 'mutation_root'; import_program: string };

export const ImportProgramDocument = `
    mutation ImportProgram($object: ImportProgramInput!) {
  import_program(object: $object)
}
    ` as string & TypedDocumentNode<ImportProgramMutation, ImportProgramMutationVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    ImportProgram: build.mutation<ImportProgramMutation, ImportProgramMutationVariables>({
      query: (variables) => ({ document: ImportProgramDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useImportProgramMutation } = injectedRtkApi;
